import {
  ReactElement,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import { TkRouteContext } from "../../context/tkRouteContext";
import { useLocation, useNavigate } from "react-router-dom";
import TkStepper from "../../components/atoms/TkStepper";
import { Box, Typography } from "@mui/material";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import {
  contextText,
  contextText2,
  fakeTableList,
  headList,
  schema,
  stepperData,
} from "./parts";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import {
  httpAPI_BUS004,
  httpAPI_COM005,
  httpAPI_COM009,
  httpIAPI_CON030,
  httpIAPI_CON008,
  httpIAPI_CON015,
  httpIAPI_CON031,
  httpIAPI_CON032,
} from "./api/request";
import TkButton from "../../components/atoms/TkButton";
import TkDownloadLink from "../../components/atoms/TkDownloadLink";
import TkFileUpload from "../../components/molecules/TkFileUpload";
import TkTable from "../../components/atoms/TkTable";
import {
  IAPI_BUS004_Request,
  IAPI_CON008_Response,
  IAPI_CON015_Request,
} from "../../type/apiType";
import TkDialog from "../../components/atoms/TkDialog";
import {
  ConfirmStatus,
  FacilityKind,
  FormClassApply,
  formClassCorp,
  FormKbn,
} from "../../assets/data/Constants";
import { TkGetCode } from "../../utils/TkGetCode";
import "./_style.scss";
import _ from "lodash";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";

/**
 * SCRC050113 契約解除（加入者全員の同意）　内容入力
 * 契約解除（加入者全員の同意）内容入力
 * @returns SCRC050113
 */
const SCRC050113 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const { state, setState } = useContext(GlobalContext);
  const { state: stateRouter } = useContext(TkRouteContext);

  const [formTableList, setFormTableList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const [bottomTableBodyList, setBottomTableBodyList] = useState<any>([]);

  //一時保存Stepperを更新するState
  const [checkAndSubmitstepper, setCheckAndSubmitStepper] = useState<number>();
  const [open, setOpen] = useState(false);
  const userType = state?.authInfo?.userType;
  const [openText, setOpenText] = useState(false);
  // 解除同意書作成依頼フラグ 0:false 1:true
  const [isVisiblePattern, setIsVisiblePattern] = useState<
    boolean | undefined
  >();
  const clickBtn = useRef(false);
  const isUserTypeKiko = userType === authorityUserType.userTypeNumber.KIKO;
  const contractorNo = isUserTypeKiko
    ? businessState.common?.contractorNo
    : state.authInfo?.contractorNo;

  const timerId = useRef<NodeJS.Timeout | null>(null);
  const facilityNoList = useRef<{ facilityNo?: string }[]>();

  const apiRes = useRef<IAPI_CON008_Response>({});
  const applyId = location.state?.applyId ?? businessState?.job_04?.applyId;
  const resApplyId = useRef<number>();
  const formRef = useRef<any>();
  const cancelDate = useRef<string>("");
  const oldFile = useRef<any>();

  type FormListType = {
    serialNo?: number; // 連番
    facilityNo?: string; // 施設番号
    staffNo?: string; // 職員番号
    formKbn?: string; // 帳票区分
    formClass?: string; // 帳票種別
    fileName?: string; // ファイル名
    fileBase64?: string; // ファイル（base64）
  };
  const [uploadFile, setUploadFile] = useState<FormListType[]>([]);
  const [fileError, setFileError] = useState<{ id: number; errMsg: string }[]>(
    []
  );
  const [saveData, setSaveData] = useState<any>();
  const [openCheck, setOpenCheck] = useState(false);
  const [deleteStaffList, setDeleteStaffList] = useState<any>();
  const [openWarning, setOpenWarning] = useState(false);

  // 直近3カ月の退職者人数 ≠ 直近3カ月の退職者証明書登録人数 の施設が1レコードでも存在する場合、「次へ」ボタンを非活性にする。
  const notAllRegistered = useMemo(() => {
    if (!apiRes.current) return true;
    return apiRes.current?.facilityList?.some?.((f) => {
      return f?.threeMonthsRetire !== f?.threeMonthsRetireCertificate;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(apiRes.current)]);

  useEffect(() => {
    const routerList = stateRouter.routerList || [];
    if (routerList[routerList.length - 1]?.href === "/SCRC020001") {
      setOpenText(true);
    } else {
      handleInit();
    }

    // 契約者（法人）名
    let resArr = stateFakeTableList.current;
    let contractorName = resArr.find(
      (item) => item.keyword === "contractorName"
    )!;
    contractorName.showLine = isUserTypeKiko;
    contractorName.contractorNumber =
      businessState.common?.contractorNo +
      ":" +
      businessState.common?.contractorName;

    return () => {
      if (timerId.current) {
        clearTimeout(timerId.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInit = async () => {
    // 退職手当共済契約解除参照API実行
    try {
      const res = await httpIAPI_CON008({ applyId, contractorNo });

      if (res.resultCd === "I0000") {
        apiRes.current = res;
        resApplyId.current = res.applyId;
        cancelDate.current = res.cancelDate || "";
        const uploadFile: FormListType[] = [];
        res.facilityList?.forEach((facility, index) => {
          const item = res.formList?.find(
            (item) =>
              item.facilityNo === facility?.facilityNo &&
              item?.formClass === formClassCorp["契約解除同意書"] &&
              item?.fileName &&
              item?.fileBase64
          );
          if (item) {
            uploadFile.push({
              serialNo: item?.serialNo ? Number(item?.serialNo) : index + 1,
              fileName: item?.fileName,
              fileBase64: item?.fileBase64,
              facilityNo: facility?.facilityNo,
              formKbn: item?.formKbn,
              formClass: item?.formClass,
            });
          } else {
            uploadFile.push({});
          }
        });
        setUploadFile(uploadFile);

        facilityNoList.current = res?.facilityList?.map((item) => ({
          facilityNo: item.facilityNo,
        }));
        setIsVisiblePattern(res.requestFlg === "1");
        if (res.requestFlg === "1") {
          handleDownloadData([]);
        }

        setBusinessState({
          ...businessState,
          job_04: {
            ...businessState.job_04,
            applyId: res.applyId,
            tempSaveStep: res.tempSaveStep,
          },
        });
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    const res = apiRes.current;
    setBottomTableBodyList(initBottomBodyList(res));

    // top table
    let resArr = stateFakeTableList.current;
    let staffNum = isVisiblePattern ? res?.maStaffNum : "-";
    resArr.find((item) => item.keyword === "maStaffNum")!.text =
      staffNum + "人";
    resArr.find((item) => item.keyword === "cancelDate")!.disabled =
      isVisiblePattern;
    resArr.find((item) => item.keyword === "cancelDate")!.setDefaultValue =
      res?.cancelDate;
    resArr.find((item) => item.keyword === "cancelDate")!.onGetInputValue = (
      e: any
    ) => handleChangeCancelDate(e.target.value);

    resArr.find((item) => item.keyword === "cancelReason")!.disabled =
      isVisiblePattern;
    resArr.find((item) => item.keyword === "cancelReason")!.setDefaultValue =
      res?.cancelReason;

    resArr.find((item) => item.keyword === "xxxBtn")!.node = (
      <Box className="buttonArea">
        <TkButton
          disabled={isVisiblePattern || clickBtn.current}
          onClick={() => handleCancelAgreeDoc()}
        >
          解除同意書作成依頼
        </TkButton>
      </Box>
    );

    setFormTableList([...resArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisiblePattern]);

  async function handleCancelAgreeDoc() {
    if (clickBtn.current) {
      return;
    }

    const errorMsgId = businessCheck();
    setState({
      ...state,
      errorMsgId,
    });
    if (errorMsgId) {
      return;
    }

    const today = new Date();
    const nextYearDate = new Date(
      today.setFullYear(today.getFullYear() + 1)
    ).setHours(0, 0, 0, 0);
    const cancelDate = new Date(
      formRef.current?.getAllValue().cancelDate
    ).setHours(0, 0, 0, 0);
    if (cancelDate >= nextYearDate) {
      //入出力項目.解除年月日 ≧ システム日付 + 1年
      setOpenWarning(true);
      return;
    }

    formRef.current?.submit();
  }

  const handleChangeCancelDate = (val: string) => {
    cancelDate.current = val;
    let bodyList = initBottomBodyList(apiRes.current);
    setBottomTableBodyList((prev: any) => {
      return prev?.map((d: any, i: any) => {
        d[3] = bodyList[i][3];
        return d;
      });
    });
  };

  useEffect(() => {
    let resArr = stateFakeTableList.current;
    resArr.find((item) => item.keyword === "facilityList")!.node = (
      <Box className="table">
        <TkTable headList={headList} bodyList={bottomTableBodyList} />
      </Box>
    );
    setFormTableList([...resArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bottomTableBodyList]);

  useEffect(() => {
    let bodyList = initBottomBodyList(apiRes.current);
    setBottomTableBodyList((prev: any) => {
      return prev?.map((d: any, i: any) => {
        d[6] = bodyList[i][6];
        return d;
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileError]);

  const handleUpload = (e: any, facilityList: any, type: any) => {
    const upFile = e.target;
    const newFileForCompare = _.cloneDeep(upFile);

    const idx = e.target?.id;
    const formName = e.target?.value?.[0]?.formName;
    const fileBase64 = e.target?.value?.[0]?.fileBase64;
    const newFile = [...uploadFile];
    const newFileError = [...fileError];

    if (type === "remove") {
      newFile[idx] = {};
      newFileError[idx] = { id: idx, errMsg: "" };
      setUploadFile(newFile);
      setFileError([...newFileError]);
      return;
    }
    if (!idx || !formName || !fileBase64) {
      return;
    }

    oldFile.current = newFileForCompare;
    const newItem: FormListType = {
      serialNo: uploadFile?.[idx]?.serialNo
        ? Number(uploadFile?.[idx]?.serialNo)
        : Number(idx + 1),
      fileName: formName ?? "",
      fileBase64: fileBase64 ?? "",
      facilityNo: facilityList.facilityNo,
      formKbn: FormKbn["法人書類"],
      formClass: formClassCorp["契約解除同意書"],
    };
    newFileError[idx] = {
      id: idx,
      errMsg:
        formName || facilityList.facilityStaffNum === 0
          ? ""
          : TkPropertyMessageGet("TKMSG_SCR0044E"),
    };
    newFile[idx] = newItem;
    setUploadFile(newFile);
    setFileError([...newFileError]);
  };

  function initBottomBodyList(
    res: IAPI_CON008_Response,
    button?: ReactElement
  ) {
    const facilityBodyList: any[] =
      res?.facilityList?.map((facilityList, index) => {
        let threeMonthsRetireStaffNum = isVisiblePattern
          ? !facilityList.threeMonthsRetire
            ? "不要"
            : facilityList.threeMonthsRetire ===
              facilityList.threeMonthsRetireCertificate
            ? `完了（${facilityList.threeMonthsRetireCertificate}人 / ${facilityList.threeMonthsRetire}人）`
            : `未完了（${facilityList.threeMonthsRetireCertificate ?? 0}人 / ${
                facilityList.threeMonthsRetire
              }人）`
          : "未完了（-人 / -人）";
        return [
          {
            id: facilityList.facilityNo,
          },
          {
            children: `${facilityList.facilityNo ?? ""}:${
              facilityList.facilityName ?? ""
            }`,
          },
          {
            children:
              FacilityKind[
                String(facilityList.facilityKind) as keyof typeof FacilityKind
              ],
          },
          {
            children: (
              <Box className="buttonArea">
                <TkButton
                  onClick={() =>
                    handleClickShowBtn(
                      facilityList.facilityNo!,
                      facilityList.facilityName!,
                      facilityList.facilityKind!,
                      cancelDate.current
                    )
                  }
                  disabled={!isVisiblePattern}
                >
                  表示
                </TkButton>
              </Box>
            ),
          },
          {
            children: (
              <Box className="buttonArea">
                <TkButton
                  onClick={() =>
                    handleClickRegisterBtn(facilityList.facilityNo)
                  }
                  disabled={!isVisiblePattern}
                >
                  登録
                </TkButton>
                <Typography>{threeMonthsRetireStaffNum}</Typography>
              </Box>
            ),
            align: "center",
          },
          {
            children:
              facilityList.facilityStaffNum && button ? (
                button
              ) : (
                <TkButton disabled>ダウンロード</TkButton>
              ),
            align: "center",
          },
          {
            children: (
              <TkFileUpload
                id={index.toString()}
                wantToSetValue={
                  uploadFile[index]?.fileName && uploadFile[index]?.fileBase64
                    ? [
                        {
                          formName: uploadFile[index]?.fileName ?? "",
                          fileBase64: uploadFile[index]?.fileBase64 ?? "",
                        },
                      ]
                    : []
                }
                onGetValues={(e, type) => {
                  handleUpload(e, facilityList, type);
                }}
                error={!!fileError[index]?.errMsg}
                errorMsg={fileError[index]?.errMsg ?? ""}
                disabled={
                  facilityList.facilityStaffNum === 0 || !isVisiblePattern
                }
              />
            ),
          },
        ];
      }) || [];

    return facilityBodyList;
  }

  //「表示」ボタンのイベント
  const handleClickShowBtn = async (
    facilityNo: string,
    facilityName: string,
    kindCd: string,
    cancelDate?: string
  ) => {
    navigate("/SCRC050111", {
      state: { facilityNo, facilityName, kindCd, cancelDate },
    });
  };

  //「登録」ボタンのイベント
  const handleClickRegisterBtn = async (facilityNo?: string) => {
    navigate("/SCRC050115", {
      state: { facilityNo },
    });
  };

  const makeHttpObj = (obj: any): IAPI_CON015_Request => {
    let facilityList = _.cloneDeep(apiRes.current?.facilityList);
    return {
      applyId: applyId,
      tempSaveStep: 1,
      contractorNo: contractorNo,
      cancelDate: obj.cancelDate,
      cancelDayMaStaffNum: apiRes.current.maStaffNum,
      cancelReason: obj.cancelReason,
      facilityList: facilityList?.map((item) => ({
        facilityNo: item.facilityNo,
        facilityKind: item.facilityKind,
      })),
      formList: uploadFile?.filter?.(
        (item) => item?.fileBase64 && item?.fileName
      ),
      receptionDate: obj.receptionDate,
      screenId: "SCRC050113",
    };
  };

  const makeHttpObjBus004 = (): IAPI_BUS004_Request => {
    return {
      checkedFlg: "0",
      contractorNo: contractorNo,
      facilityList: facilityNoList.current ?? [],
      cancelDate: formRef.current?.getAllValue().cancelDate,
    };
  };

  const handleDownloadData = async (history: any[]) => {
    // 帳票作成状況取得API実行
    try {
      const res = await httpAPI_COM009({
        applyId: resApplyId.current ?? applyId,
        FormList: [
          {
            formClass: FormClassApply["解除同意書"],
            formKbn: FormKbn["申請"],
          },
        ],
      });

      if (res.resultCd === "I0000") {
        res.FormList?.forEach((item) => {
          if (
            item.formOutputStatus === "3" &&
            !history.includes(item.requestId)
          ) {
            history.push(item.requestId);
            handleDownLoadFile(
              [{ requestId: item.requestId }],
              item.facilityNo
            );
          }
        });

        if (
          !res.FormList?.every((item) => item.formOutputStatus === "3") ||
          !res.FormList?.length
        ) {
          // 10秒間待機後 再度APIリクエストを送信
          timerId.current = setTimeout(() => {
            handleDownloadData(history);
          }, 10000);
        }
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleDownLoadFile = async (formList: any, facilityNo: any) => {
    // 帳票ダウンロード(汎用) 実行
    try {
      const res = await httpAPI_COM005({ formList });

      if (res.resultCd === "I0000") {
        let file = res.formList?.[0];
        let button = (
          <TkDownloadLink
            dataname={TkGetCode(FormClassApply, file?.formClass)}
            base64filedata={file?.fileBase64 ?? ""}
            downloadBase64
            isButton
            buttonName="ダウンロード"
          />
        );
        let bodyList = initBottomBodyList(apiRes.current, button);

        setTimeout(() => {
          setBottomTableBodyList((prev: any) => {
            return prev?.map((d: any, i: any) => {
              if (d[0].id === facilityNo) {
                d[5] = bodyList[i][5];
              }
              return d;
            });
          });
        }, 0);
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch {
      navigate("/error");
    }
  };

  const businessCheck = (): string => {
    let errorMsg = "";
    const cancelDate = new Date(formRef.current?.getAllValue().cancelDate);
    const year = state.authInfo?.fiscalYear!;
    const confirmStatus = state.authInfo?.confirmStatus;
    if (
      !(
        confirmStatus === ConfirmStatus["確定済"] ||
        confirmStatus === ConfirmStatus["過去年度"]
      )
    ) {
      // 当年度の確定前、かつ入出力項目.解除年月日 ≦ 前年３月３１日に変更
      if (cancelDate <= new Date(`${year - 1}-03-31`)) {
        errorMsg = "TKMSG_SCR0108E";
      }
    }
    return errorMsg;
  };

  //一時保存押下ダイヤログ時に発生するイベント
  const handleSubmit = async (data: any, index: any, isRefSubmit?: boolean) => {
    setSaveData(data);
    if (isRefSubmit) {
      clickBtn.current = true;
      if (
        formRef.current?.getAllValue().cancelDate === "" ||
        formRef.current?.getAllValue().cancelReason === ""
      ) {
        return;
      }

      try {
        const res = await httpAPI_BUS004({
          ...makeHttpObjBus004(),
        });
        if (res.resultCd === "I0000") {
          const con032Res = await httpIAPI_CON032({
            contractorNo: contractorNo || "",
            applyId: applyId,
            cancelDate: formRef.current?.getAllValue().cancelDate,
            cancelReason: formRef.current?.getAllValue().cancelReason,
          });
          if (con032Res.resultCd === "I0000") {
            apiRes.current = {
              ...apiRes.current,
              ...con032Res,
            };

            resApplyId.current = con032Res.applyId;

            setBusinessState({
              ...businessState,
              job_04: {
                ...businessState.job_04,
                applyId: con032Res.applyId,
              },
            });
            setIsVisiblePattern(true);
            handleDownloadData([]);
            setState({ ...state, errorMsgId: "" });
          } else {
            clickBtn.current = false;
            setState({ ...state, errorMsgId: con032Res.resultCd });
          }
        } else {
          clickBtn.current = false;
          setState({ ...state, errorMsgId: res.resultCd });
        }
      } catch (error) {
        clickBtn.current = false;
        navigate("/error");
      }

      return;
    }
    let newFileError = [...fileError];
    let hasError = false;
    apiRes.current?.facilityList?.forEach((facility: any, idx: number) => {
      if (facility.facilityStaffNum !== 0 && !uploadFile[idx]?.fileName) {
        newFileError[idx] ??= { id: idx, errMsg: "" };
        newFileError[idx].errMsg = TkPropertyMessageGet("TKMSG_SCR0044E");
        hasError = true;
      }
    });
    if (hasError) {
      setFileError([...newFileError]);
      return;
    }
    switch (index) {
      case 0: // 一時保存
        // 退職手当共済契約解除更新API実行
        try {
          const res = await httpIAPI_CON015({
            ...makeHttpObj(data),
          });
          if (res.resultCd === "I0000") {
            setBusinessState({
              ...businessState,
              job_04: {
                ...businessState.job_04,
                applyId: res.applyId,
              },
            });
            setOpen(true);
            setCheckAndSubmitStepper(1);
          } else {
            setState({ ...state, errorMsgId: res.resultCd });
          }
        } catch (error) {
          navigate("/error");
        }
        break;

      case 1: // 次へ
        try {
          // 契約解除時の退職手当金請求者有無チェックAPIを呼び出す
          const res = await httpAPI_BUS004({
            ...makeHttpObjBus004(),
          });
          if (res.resultCd === "I0000") {
            const resCON031 = await httpIAPI_CON031({
              applyId: applyId,
              businessType: businessState.common?.businessType,
              contractorNo: contractorNo,
            });
            if (resCON031.resultCd === "I0000") {
              if (!!resCON031.staffNoInfoList?.length) {
                setDeleteStaffList(resCON031.staffNoInfoList);
                setOpenCheck(true);
              } else {
                setState({ ...state, errorMsgId: "" });
                navigate("/SCRC050016", {
                  state: {
                    cancelDate: data?.cancelDate,
                    maStaffNum: apiRes.current?.maStaffNum ?? 0,
                    cancelReason: data?.cancelReason,
                    facilityList: apiRes.current?.facilityList?.map((item) => ({
                      facilityNo: item.facilityNo,
                      facilityKind: item.facilityKind,
                    })),
                    formList: uploadFile?.filter?.(
                      (item) => item?.fileBase64 && item?.fileName
                    ),
                  },
                });
              }
            } else {
              setState({ ...state, errorMsgId: resCON031.resultCd });
            }
          } else {
            setState({ ...state, errorMsgId: res.resultCd });
          }
        } catch (error) {
          navigate("/error");
        }
        break;
    }
  };

  const onSave = async () => {
    setOpenCheck(false);
    try {
      const res = await httpIAPI_CON030({
        contractorNo: contractorNo,
        staffNoInfoList: deleteStaffList,
        businessType: businessState.common?.businessType,
        applyId: applyId,
      });
      if (res.resultCd === "I0000") {
        setState({ ...state, errorMsgId: "" });
        navigate("/SCRC050016", {
          state: {
            cancelDate: saveData?.cancelDate,
            maStaffNum: apiRes.current?.maStaffNum ?? 0,
            cancelReason: saveData?.cancelReason,
            facilityList: apiRes.current?.facilityList?.map((item) => ({
              facilityNo: item.facilityNo,
              facilityKind: item.facilityKind,
            })),
            formList: uploadFile?.filter?.(
              (item) => item?.fileBase64 && item?.fileName
            ),
          },
        });
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleDiglogCancelEvent = () => {
    handleInit();
    setOpenText(false);
  };

  //従業状況の更新(ダイアログ)ボタンを押下施設一覧画面(SCRC050114)に遷移する
  const handleStatusUpdate = () => {
    setBusinessState({
      ...businessState,
      job_04: {
        ...businessState.job_04,
        applyId: applyId,
      },
    });
    setOpenText(false);
    navigate("/SCRC050114");
  };

  const onClickWarningOk = () => {
    setOpenWarning(false);
    formRef.current?.submit();
  };

  return (
    <Box data-testid="SCRC050113test">
      <TkDialog
        cancelText="次へ"
        okText="従業状況の更新"
        onSave={handleStatusUpdate}
        onCancel={handleDiglogCancelEvent}
        open={openText}
      >
        <Box className="SCRC50113ContextText">
          <TkInfoManual rule={"<"}>{contextText}</TkInfoManual>
        </Box>
      </TkDialog>
      {!openText && (
        <Box className="SCRC050113" data-testid="SCRC050113PageForTest">
          <TkStepper
            steps={stepperData}
            activeStep={0}
            savaStep={checkAndSubmitstepper}
          />

          <TkFakeTable
            list={formTableList}
            ruleSchema={schema}
            submitButtonGroup={[
              { submitButtonText: "一時保存" },
              {
                submitButtonText: "次へ",
                submitButtonDisabled: !isVisiblePattern || notAllRegistered,
              },
            ]}
            buttonGroup={<TkBackButton />}
            onCheckAndSubmit={handleSubmit}
            ref={formRef}
          />

          <TkDialog
            open={open}
            onSave={() => setOpen(false)}
            title="一時保存完了"
            contextText="　一時保存が完了しました。"
            okText="はい"
            cancelText=""
          />
          <TkDialog
            title="確認（退職(予定)年月日・異動情報(配置換え)が削除されます）"
            children={<TkInfoManual rule={"<"}>{contextText2}</TkInfoManual>}
            okText="はい"
            cancelText="いいえ"
            open={openCheck}
            onSave={() => onSave()}
            onCancel={() => setOpenCheck(false)}
          />
          <TkMessageDialog
            open={openWarning}
            onOky={onClickWarningOk}
            onCancel={() => setOpenWarning(false)}
            onClose={() => setOpenWarning(false)}
            title="警告"
            contextText={TkPropertyMessageGet("TKMSG_SCR0032W")}
            okText="確認"
            cancelText="戻る"
          />
        </Box>
      )}
    </Box>
  );
};

export default SCRC050113;
